<template>
	<div>
		<b-form-checkbox v-model="none" @change="emitChangeEvent">
			Es ist keine bestimmte Staatsbürgerschaft erforderlich
		</b-form-checkbox>
		<div v-if="!none" class="mt-4">
			<CountryAutocomplete
				v-model="items"
				:meta="meta"
				@input="emitChangeEvent"
			/>
		</div>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import CountryAutocomplete from "@/vue/common/form/CountryAutocomplete";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {
	components: {
		CountryAutocomplete
	},

	props: {
		value: {
			Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		let none = false;
		let items = [];

		if (isDefined(this.value))
		{
			none = this.value.length === 0;
			items = this.value;
		}

		return {
			none,
			items,
		};
	},

	computed: {
		dataValid ()
		{
			return this.none || arrayIsNotEmpty(this.items);
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', this.none ? [] : this.items);
		},
	},
}
</script>
